export const iconFontAwesomeMathematicsPlusMinus = (
	<i className="fa-solid fa-plus-minus"></i>
);
